import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  CircularProgress,
  Paper,
  CssBaseline,
  Fade,
  InputAdornment,
  IconButton,
  Link as MUILink
} from '@mui/material';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Property_pincoder_new from "./../../../src/Images/property_pincode_new.png"
import { BASE_URL } from '../Api/ApiUrls';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [step, setStep] = useState('email'); // 'email', 'otp', 'reset'
  const navigate = useNavigate();

  const handleSendOtp = async () => {
  setLoading(true);
  setError('');

  try {
    await axios.post(`${BASE_URL}/send-otp/`, { email });
    setStep('otp');
  } catch (error) {
    // ✅ Better user-friendly message
    if (error.response && error.response.status === 404) {
      setError("Email not found. Please Register first.");
    } else {
      setError("Unable to send OTP right now. Please try again later.");
    }
  }

  setLoading(false);
};

  const handleVerifyOtp = async () => {
    setLoading(true);
    setError('');
    try {
      await axios.post(`${BASE_URL}/verify-otp/`, { email, otp });
      setStep('reset');
    } catch (error) {
      setError('Invalid OTP. Please try again.');
    }
    setLoading(false);
  };

  const handleResetPassword = async () => {
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    setError('');
    try {
      await axios.post(`${BASE_URL}/reset-password/`, {
        email,
        otp,
        password: newPassword,
      });
      alert('Password updated successfully');
      navigate('/');
    } catch (error) {
      setError('Failed to reset password');
    }
    setLoading(false);
  };

  return (
    <Fade in timeout={700}>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #0d0d25, #000)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 6,
        }}
      >
        <Container maxWidth="xs">
          <CssBaseline />
          <Paper
            elevation={10}
            sx={{
              p: 4,
              borderRadius: 4,
              background: 'rgba(255, 255, 255, 0.02)',
              border: '1px solid rgba(255, 215, 0, 0.3)',
              backdropFilter: 'blur(10px)',
              textAlign: 'center',
              color: '#fff',
            }}
          >
            <Box
              component="img"
              src={Property_pincoder_new}
              alt="Land Nest Logo"
              sx={{
                width: 180,
                height: 120,
                mb: 2,
                mx: 'auto',
                borderRadius: 2,
                boxShadow: '0 0 20px #ffd700',
                display: 'block',
              }}
            />

            <Typography variant="h5" sx={{ color: '#f7e896', fontWeight: 600, mb: 2 }}>
              Reset Password
            </Typography>

            {error && (
              <Typography color="error" sx={{ fontSize: 14, mb: 2 }}>
                {error}
              </Typography>
            )}

            {step === 'email' && (
              <Box>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="Email Address"
                  type="email"
                  value={email}
                 // onChange={(e) => setEmail(e.target.value)}
                  onChange={(e) => setEmail(e.target.value.toLowerCase())}
                  InputProps={{
                    sx: {
                      backgroundColor: 'rgba(255,255,255,0.05)',
                      borderRadius: 2,
                      color: 'white',
                    },
                  }}
                  InputLabelProps={{ style: { color: '#ccc' } }}
                />
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleSendOtp}
                  disabled={loading}
                  sx={{
                    mt: 3,
                    mb: 2,
                    background: 'linear-gradient(135deg, #f1e57c, #e6ce45)',
                    color: '#000',
                    fontWeight: 'bold',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #ffe85c, #f0d53e)',
                    },
                  }}
                >
                  {loading ? <CircularProgress size={24} color="inherit" /> : 'Send OTP'}
                </Button>
              </Box>
            )}

            {step === 'otp' && (
              <Box>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  InputProps={{
                    sx: {
                      backgroundColor: 'rgba(255,255,255,0.05)',
                      borderRadius: 2,
                      color: 'white',
                    },
                  }}
                  InputLabelProps={{ style: { color: '#ccc' } }}
                />
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleVerifyOtp}
                  disabled={loading}
                  sx={{
                    mt: 3,
                    mb: 2,
                    background: 'linear-gradient(135deg, #f1e57c, #e6ce45)',
                    color: '#000',
                    fontWeight: 'bold',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #ffe85c, #f0d53e)',
                    },
                  }}
                >
                  {loading ? <CircularProgress size={24} color="inherit" /> : 'Verify OTP'}
                </Button>
              </Box>
            )}

            {step === 'reset' && (
              <Box>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="New Password"
                  type={showPassword ? 'text' : 'password'}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  InputProps={{
                    sx: {
                      backgroundColor: 'rgba(255,255,255,0.05)',
                      borderRadius: 2,
                      color: 'white',
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                          sx={{ color: 'rgb(248, 227, 111)' }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  InputLabelProps={{ style: { color: '#ccc' } }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="Confirm Password"
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  InputProps={{
                    sx: {
                      backgroundColor: 'rgba(255,255,255,0.05)',
                      borderRadius: 2,
                      color: 'white',
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          edge="end"
                          sx={{ color: 'rgb(248, 227, 111)' }}
                        >
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  InputLabelProps={{ style: { color: '#ccc' } }}
                />
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleResetPassword}
                  disabled={loading}
                  sx={{
                    mt: 3,
                    mb: 2,
                    background: 'linear-gradient(135deg, #f1e57c, #e6ce45)',
                    color: '#000',
                    fontWeight: 'bold',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #ffe85c, #f0d53e)',
                    },
                  }}
                >
                  {loading ? <CircularProgress size={24} color="inherit" /> : 'Update Password'}
                </Button>
              </Box>
            )}

            <MUILink
              component={Link}
              to="/"
              variant="body2"
              sx={{
                color: 'rgb(250, 225, 85)',
                display: 'block',
                mt: 2,
              }}
            >
              Back to login
            </MUILink>
          </Paper>
        </Container>
      </Box>
    </Fade>
  );
};

export default ForgotPassword;
